export default "__VITE_ASSET__d29e35a4__"